import type { ElementType, HTMLAttributes, ReactNode } from "react";
import styles from "./Card.module.css";
import { Heading } from "./Text.js";
import { cx } from "./cx.js";

interface CardProps extends Omit<HTMLAttributes<HTMLElement>, "title"> {
  title?: ReactNode;
  /** Rendered opposite the title: a month picker, a "see all" link. */
  action?: ReactNode;
  padding?: 3 | 4 | 5;
  raised?: boolean;
  interactive?: boolean;
  as?: ElementType;
  children?: ReactNode;
}

export function Card({
  title,
  action,
  padding = 4,
  raised = false,
  interactive = false,
  as: Tag = "section",
  className,
  children,
  ...rest
}: CardProps) {
  return (
    <Tag
      className={cx(
        styles.card,
        padding !== 4 && styles[`pad-${padding}`],
        raised && styles.raised,
        interactive && styles.interactive,
        className,
      )}
      {...rest}
    >
      {(title || action) && (
        <header className={styles.header}>
          {typeof title === "string" ? (
            <Heading level={3} size="lg">
              {title}
            </Heading>
          ) : (
            title
          )}
          {action}
        </header>
      )}
      {children}
    </Tag>
  );
}
